"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var node_1 = __importDefault(require("../../node"));
var react_redux_1 = require("react-redux");
var reactflow_1 = require("reactflow");
var workflow_1 = require("../../../../../../../../reducers/slices/workflow/workflow");
var react_1 = require("react");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var main_1 = require("../../../../../../../../reducers/slices/main");
var fields_from_schema_1 = require("../../../helpers/fields_from_schema");
var data_map_modal_1 = __importDefault(require("../../data_map/data_map_modal"));
var react_2 = require("@nextui-org/react");
var endpoint_data_mapper_1 = __importDefault(require("../../../../endpoint_data_mapper"));
var SaveDataNode = function (props) {
    var _a;
    var data = props.data;
    var _b = (0, react_1.useState)(((_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.collectionName) || "ORDER"), selectedCollection = _b[0], setSelectedCollection = _b[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var setNodeData = function (data) {
        dispatch((0, workflow_1.setNode)(__assign(__assign({}, props), { data: data })));
    };
    var flow = null;
    try {
        flow = (0, reactflow_1.useReactFlow)();
    }
    catch (error) {
        if (props.id) {
            console.error(error);
        }
    }
    var getSchema = function () {
        if (flow) {
            var nodes = flow.getNodes();
            var edges = flow.getEdges();
            return (0, fields_from_schema_1.combineSchemas)(props, nodes, edges);
        }
        return null;
    };
    var collectionNameOptions = [
        { label: "Order", value: "ORDER" },
        { label: "Customer", value: "CUSTOMER" },
        { label: "Custom", value: "CUSTOM" },
    ];
    var configurationComponent = function () { return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-2" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Select, __assign({ label: "Target:", labelPlacement: "outside", selectedKeys: selectedCollection ? [selectedCollection] : [], onSelectionChange: function (keys) {
                        var selectedKey = Array.from(keys)[0];
                        setSelectedCollection(selectedKey || "");
                        setNodeData(__assign(__assign({}, data), { config: __assign(__assign({}, data.config), { collectionName: selectedKey }) }));
                    } }, { children: collectionNameOptions.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_2.SelectItem, { children: option.label }, option.value)); }) })), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: "secondary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var schema;
                        var _a;
                        return __generator(this, function (_b) {
                            schema = getSchema();
                            dispatch((0, main_1.setContentModal)({
                                title: selectedCollection === "CUSTOM" ? "Build Custom Schema" : "Map your fields",
                                content: selectedCollection === "CUSTOM" ? ((0, jsx_runtime_1.jsx)(endpoint_data_mapper_1.default, { value: data.config.fields, onChange: function (fields) {
                                        setNodeData(__assign(__assign({}, data), { config: __assign(__assign({}, data.config), { fields: fields }) }));
                                    } })) : ((0, jsx_runtime_1.jsx)(data_map_modal_1.default, { schema: schema, value: (_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.mapping, onSave: function (mapping) {
                                        setNodeData(__assign(__assign({}, data), { config: __assign(__assign({}, data === null || data === void 0 ? void 0 : data.config), { mapping: mapping }) }));
                                    } })),
                            }));
                            return [2 /*return*/];
                        });
                    }); } }, { children: selectedCollection === "CUSTOM" ? "Build Custom Schema" : "Map ".concat(selectedCollection || "selected", " fields") }))] })) })); };
    return ((0, jsx_runtime_1.jsxs)(node_1.default, __assign({ category: "action", icon: pro_light_svg_icons_1.faSave, configurationComponent: configurationComponent, data: data }, props, { children: [(0, jsx_runtime_1.jsx)(reactflow_1.Handle, { type: "target", position: reactflow_1.Position.Left, className: "rounded w-2 h-5 !bg-blue-300" }), (0, jsx_runtime_1.jsx)(reactflow_1.Handle, { type: "source", position: reactflow_1.Position.Right, className: "rounded w-2 h-5 !bg-secondary" })] })));
};
exports.default = (0, react_1.memo)(SaveDataNode);
